import { FC, ReactElement } from 'react'
import { createPortal } from 'react-dom'

import { NotificationsPopover } from '@/compositions/NotificationsPopover/NotificationsPopover'
import { NotificationItem } from '@/entities/Notification/Notification'
import { NAVIGATION_NOTIFICATIONS_SLOT_ID } from '@/helpers/notificationsSlot'
import { usePortalSlot } from '@/hooks/usePortalSlot'

interface HeaderNotificationsProps {
    notifications: NotificationItem[]
    unreadCount: number
    loading?: boolean
    onMarkAllRead: () => void
    onNotificationClick?: (notification: NotificationItem) => void
}

export const HeaderNotifications: FC<HeaderNotificationsProps> = ({
    notifications,
    unreadCount,
    loading,
    onMarkAllRead,
    onNotificationClick,
}): ReactElement => {
    const slotElement = usePortalSlot(NAVIGATION_NOTIFICATIONS_SLOT_ID)

    const popover = (
        <NotificationsPopover
            notifications={notifications}
            unreadCount={unreadCount}
            loading={loading}
            onMarkAllRead={onMarkAllRead}
            onNotificationClick={onNotificationClick}
        />
    )

    return slotElement ? createPortal(popover, slotElement) : popover
}
